import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, FormControlLabel, Checkbox,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DriveFile } from '../services/myDriveService';

interface Props {
  open: boolean;
  file: DriveFile | null;
  onConfirm: (recursive: boolean) => void;
  onClose: () => void;
}

export default function DeleteConfirmDialog({ open, file, onConfirm, onClose }: Props) {
  const { t } = useTranslation();
  const [recursive, setRecursive] = useState(false);

  if (!file) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('myDrive.delete', '刪除')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('myDrive.deleteConfirm', '確定刪除「{name}」嗎？').replace('{name}', file.filename)}
        </Typography>
        {file.is_directory && (
          <FormControlLabel
            sx={{ mt: 1 }}
            control={<Checkbox checked={recursive} onChange={e => setRecursive(e.target.checked)} />}
            label={t('myDrive.errFolderNotEmpty', '遞迴刪除所有子項目')}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel', '取消')}</Button>
        <Button variant="contained" color="error"
                onClick={() => { onConfirm(recursive); setRecursive(false); }}>
          {t('myDrive.delete', '刪除')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
